import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/foundation/modelDetail';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    // Identity is family + slug. Legacy callers that only pass a
    // PredictFM ``version`` resolve to family=predictfm, slug=version.
    const family = encodeURIComponent(action.payload?.family || 'predictfm');
    const slug = encodeURIComponent(
      action.payload?.slug || action.payload?.version || '');
    const response = yield call(
      axios.get,
      `${config.API_URL}/models/foundation/${family}/${slug}`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
